import React from "react";
import { BellOff, Bell, BellRing } from "lucide-react";
import { useIntl } from "react-intl";
import "./RequestTypeToggle.scss"

const RequestTypeToggle = ({ topicId, requestType, onChange, onClick, locked = false }) => {
    const intl = useIntl();

    // Define the three states
    const requestTypes = [
        {
            value: "noRequests",
            icon: BellOff,
            label: intl.formatMessage({
                id: 'bot.requestType.noRequests',
                defaultMessage: 'No support requests',
            }),
            className: "no-requests"
        },
        {
            value: "requestWithConsent",
            icon: Bell,
            label: intl.formatMessage({
                id: 'bot.requestType.requestWithConsent',
                defaultMessage: 'Support requests with consent',
            }),
            className: "with-consent"
        },
        {
            value: "createRequest",
            icon: BellRing,
            label: intl.formatMessage({
                id: 'bot.requestType.createRequest',
                defaultMessage: 'Always create support requests',
            }),
            className: "create-request"
        }
    ];

    const lockedType = requestTypes[0]; // always "no-requests" when locked

    // Find current state index
    const currentIndex = requestTypes.findIndex(type => type.value === requestType);

    // Handle click to cycle through states
    const handleToggle = (e) => {
        if (locked) return;
        // Stop propagation to prevent collapsing the topic when clicking the toggle
        if (onClick) {
            onClick(e);
        } else {
            e.stopPropagation();
        }

        const nextIndex = (currentIndex + 1) % requestTypes.length;
        onChange(topicId, "requesttype", requestTypes[nextIndex].value);
    };

    // Current request type — when locked, always show "no requests"
    const currentType = locked ? lockedType : requestTypes[currentIndex !== -1 ? currentIndex : 1];
    const IconComponent = currentType.icon;

    return (
        <div
            className={`request-type-toggle ${currentType.className}${locked ? ' locked' : ''}`}
            onClick={handleToggle}
            aria-label={`Toggle request type: ${currentType.label}`}
            aria-disabled={locked}
        >
            <IconComponent size={18} />
            <span className="request-type-label">{currentType.label}</span>
        </div>
    );
};

export default RequestTypeToggle;